var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonWithPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_user-cirlce-add",
    "data-name": "vuesax/bold/user-cirlce-add",
    transform: "translate(-684 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-cirlce-add",
    transform: "translate(684 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.78,1.1A3.271,3.271,0,0,0,3.317,0,3.313,3.313,0,0,0,.937,1,3.272,3.272,0,0,0,.166,2.272,3.362,3.362,0,0,0,0,3.317,3.252,3.252,0,0,0,.481,5.026a3.055,3.055,0,0,0,.63.755,3.252,3.252,0,0,0,2.206.854A3.057,3.057,0,0,0,4.354,6.46a3.233,3.233,0,0,0,1.8-1.435,3.1,3.1,0,0,0,.381-.937,2.98,2.98,0,0,0,.1-.771A3.3,3.3,0,0,0,5.78,1.1ZM4.553,3.923H3.939v.647a.622.622,0,0,1-1.244,0V3.923H2.082a.622.622,0,0,1,0-1.244H2.7V2.09a.622.622,0,0,1,1.244,0v.589h.614a.622.622,0,0,1,0,1.244Z",
    transform: "translate(12.536 0.829)",
    fill: "#f4906a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M16.683,8.341a8.192,8.192,0,0,0-.6-3.1,3.178,3.178,0,0,1-.859.425,2.815,2.815,0,0,1-.284.083,7.073,7.073,0,0,1-1.56,7.574,3.86,3.86,0,0,0-.918-.834,8.026,8.026,0,0,0-8.241,0,4.028,4.028,0,0,0-.918.834A7.083,7.083,0,0,1,10.927,1.743c.025-.1.05-.192.083-.292A2.929,2.929,0,0,1,11.444.6a8.192,8.192,0,0,0-3.1-.6A8.33,8.33,0,0,0,2.694,14.464c0,.008,0,.008-.008.017.083.083.184.15.267.225a1.748,1.748,0,0,0,.142.117c.15.125.317.242.475.359l.167.117a4.966,4.966,0,0,0,.5.3c.058.033.125.075.184.108a5.083,5.083,0,0,0,.526.25,2.133,2.133,0,0,0,.2.092q.275.113.551.2a1.877,1.877,0,0,0,.2.067c.2.058.4.108.6.158a1.184,1.184,0,0,0,.184.042,6.6,6.6,0,0,0,.709.108.419.419,0,0,1,.1.017c.284.025.567.042.851.042s.567-.017.842-.042a.419.419,0,0,0,.1-.017,6.6,6.6,0,0,0,.709-.108c.058-.008.117-.033.184-.042.2-.05.409-.092.6-.158a1.877,1.877,0,0,1,.2-.067c.184-.067.375-.125.551-.2a2.133,2.133,0,0,0,.2-.092q.263-.113.526-.25c.067-.033.125-.075.184-.108.167-.1.334-.192.5-.3a2.024,2.024,0,0,0,.167-.117c.167-.117.325-.234.475-.359a1.748,1.748,0,0,1,.142-.117c.092-.075.184-.15.267-.225,0-.008,0-.008-.008-.017A8.3,8.3,0,0,0,16.683,8.341Z",
    transform: "translate(1.659 1.659)",
    fill: "#f4906a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.11,0a3.106,3.106,0,0,0-.041,6.211h.149A3.107,3.107,0,0,0,3.11,0Z",
    transform: "translate(6.89 5.788)",
    fill: "#f4906a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWithPlusCircle);
export default __webpack_public_path__ + "static/media/person_with_plus-circle.d0c94795b0e0f9b643d2aaa05e7abfe0.svg";
export { ForwardRef as ReactComponent };